import { render, staticRenderFns } from "./handpickAuthorAdd.vue?vue&type=template&id=743f2373&scoped=true&"
import script from "./handpickAuthorAdd.vue?vue&type=script&lang=js&"
export * from "./handpickAuthorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743f2373",
  null
  
)

export default component.exports